import { createContext, useContext, useState } from 'react';

// Auth Context
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem('shweebum_user');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  const login = (userData) => {
    // Nuclear clear: remove ALL shweebum-related localStorage to prevent cross-user data leaks
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('shweebum_') || key.startsWith('backup_') || key.startsWith('project_') || key.startsWith('draft_'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // Clear session storage too
    sessionStorage.clear();
    
    // Set new user data
    setUser(userData);
    localStorage.setItem('shweebum_user', JSON.stringify(userData));
    localStorage.setItem('shweebum_login_ts', String(Date.now()));
    if (userData.token) {
      localStorage.setItem('shweebum_token', userData.token);
    }
  };

  const logout = () => {
    // Nuclear clear: remove ALL shweebum-related localStorage to ensure complete privacy
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('shweebum_') || key.startsWith('backup_') || key.startsWith('project_') || key.startsWith('draft_'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => {
      try { localStorage.removeItem(key); } catch(e) {}
    });
    
    sessionStorage.clear();
    
    // Clear React state then force navigate
    setUser(null);
    
    // Use document.location for most reliable redirect
    document.location = '/';
  };

  const updateUser = (updates) => {
    if (!user) return;
    const newUser = { ...user, ...updates };
    setUser(newUser);
    localStorage.setItem('shweebum_user', JSON.stringify(newUser));
  };

  const getToken = () => {
    return localStorage.getItem('shweebum_token');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
